import { PageNotFound } from '@crehana/compass.ui/page-not-found';

const WhatsappTemplatesImportNotFound = () => {
  return <PageNotFound />;
};

export default WhatsappTemplatesImportNotFound;
